import Vue from 'vue';
import basicTheme from '@/styles/theme.json';

export default {
  namespaced: true,
  state: {
    colorScheme: 'dark',
    theme: basicTheme,
  },
  getters: {
    get: (state) => (key) => state[key] || null,
  },
  mutations: {
    set(state, { key, value }) {
      if (typeof state[key] !== 'undefined') {
        Vue.set(state, key, value);
      }
    },
  },
};
